(function (window, $, app) {
    var repaint;
    
    function Modal() {
        var _this = this;
        var tpl = $('#tpl-modal').html();
        var templates = {};
        
        this.getTemplate = function (name) {
            if (! templates.hasOwnProperty(name)) {
                var $tpl = $('#tpl-modal' + (name ? '-' + name : ''));
                
                if (! $tpl.length) {
                    throw 'Template ' + name + ' not found';
                }
                
                var tpl = $tpl.html();
                
                templates[name] = {
                    compile: app.Template.compile(tpl),
                    partial: $tpl.data('type') === 'partial',
                    parent: $tpl.data('parent') || null
                };
            }
            
            return templates[name];
        };
        
        this.show = function (overlayId, contentId, data) {
            var $overlay = $('#' + overlayId);
            var $content = $('#' + contentId);
            var template = _this.getTemplate(data.mdTpl);
            var tplData = {};
            var show = data.mdShow;
            
            delete data.mdShow;
            delete data.mdTpl;
            
            if ($content.length) {
                tplData.content = $content.html();
            }
            
            $.each(data, function (key, value) {
                if (key.match(/^md([A-Z])/)) {
                    key = key.replace(/^md([A-Z])/, function (match, $1) {
                        return $1.toLowerCase();
                    });
                    
                    tplData[key] = value;
                }
            });
            
            $('[data-md-inserted="true"]').remove();
            
            var $modal = $(template.compile(tplData)).attr({
                'data-md-state': 'open',
                'data-md-inserted': 'true',
                'data-md-show': show
            });
            
            if (template.partial) {
                var $data = $modal.filter('template');
                
                $.each(tplData, function (key, value) {
                    var newKey = 'md' + key[0].toUpperCase() + key.substr(1);
                    
                    tplData[newKey] = value;
                    delete tplData[key];
                });
                
                $data.each(function () {
                    tplData['md' + this.id[0].toUpperCase() + this.id.substr(1)] = $(this).html();
                });
                
                tplData.mdShow = show;
                tplData.mdTpl = template.parent;
                
                return _this.show(overlayId, '', tplData);
            }
            
            $modal.insertBefore($overlay);
            
            repaint = $modal[0].offsetWidth;
            $modal.addClass(show).data('$overlay', $overlay);
            app.$body.addClass('@md-open');
            
            $overlay.off('click', null, _this.hide).click(_this.hide);
        };
        
        this.hide = function () {
            var $modal = $('[data-md-state="open"]');
            
            $modal.attr('data-md-state', 'closed').removeClass($modal.data('md-show'));
            app.$body.removeClass('@md-open');
        };
    }
    
    app.registerModule('Modal', new Modal());
})(window, jQuery, app);
